import React from 'react';
import './App.css';
import gifEverything from './assets/artworks/everything.gif';
import gifReleasing from './assets/artworks/releasing.gif';
import gifWeWillBeOkay from './assets/artworks/wewillbeokay.gif';
import gifOurSong from './assets/artworks/oursong.gif';
import gifLetYourSoulSing from './assets/artworks/letyoursoulsing.gif';
import gifChooseToLove from './assets/artworks/choosetolove.gif';
import gifOnTheMove from './assets/artworks/onthemove.gif';
import chooseToLove from './assets/songs/ChooseToLove.mp3';
import everythingWeNeed from './assets/songs/Everything_We_Need.mp3';
import letYourSoulSing from './assets/songs/LetYourSoulSing.mp3';
import onTheMove from './assets/songs/On_The_Move.mp3';
import ourSong from './assets/songs/Our_Song.mp3';
import releasingIntentions from './assets/songs/Releasing_Intentions.mp3';
import weWillBeOkay from './assets/songs/We_Will_Be_Okay.mp3';
import { AudioPlayer, ITrack } from './AudioPlayer';

// All of these artists are at https://pixabay.com/music/search/mood/laid%20back/
const tracks: ITrack[] = [
  {
    title: 'We Will Be Okay',
    artist: 'Yoeshi',
    audioSrc: weWillBeOkay,
    image: gifWeWillBeOkay,
  },
  {
    title: 'Our Song',
    artist: 'Yoeshi',
    audioSrc: ourSong,
    image: gifOurSong,
  },
  {
    title: 'Releasing Intentions',
    artist: 'Yoeshi',
    audioSrc: releasingIntentions,
    image: gifReleasing,
  },
  {
    title: 'Everything We Need',
    artist: 'Yoeshi',
    audioSrc: everythingWeNeed,
    image: gifEverything,
  },
  {
    title: 'Let Your Soul Sing',
    artist: 'Yoeshi',
    audioSrc: letYourSoulSing,
    image: gifLetYourSoulSing,
  },
  {
    title: 'Choose To Love',
    artist: 'Yoeshi',
    audioSrc: chooseToLove,
    image: gifChooseToLove,
  },
  {
    title: 'On The Move',
    artist: 'Yoeshi',
    audioSrc: onTheMove,
    image: gifOnTheMove,
  },
];

function App() {
  return (
    <div className="App">
      <AudioPlayer tracks={tracks} />
    </div>
  );
}

export default App;
